import { Common, color, device } from '@stockbit/ui';
import styled from 'styled-components';

const { Text, Flex } = Common;

export const Subtitle = styled(Text).attrs({
  as: 'h3',
  family: 'bold',
  color: color.primary,
  align: 'center',
  size: '26px',
})`
  margin-bottom: 10px;
`;

export const Title = styled(Text).attrs({
  as: 'h1',
  family: 'bold',
  align: 'center',
})`
  margin-bottom: 60px;
  font-size: 36px;

  @media ${device.laptop} {
    font-size: 6.5vh;
  }

  @media ${device.laptopL} {
    font-size: 44px;
  }
`;

export const Box = styled(Flex).attrs({
  justify: 'space-between',
})`
  flex-direction: column;
  padding: 32px 20px;
  border: solid 1px ${color.downgray};
  border-radius: 2px;
  font-size: 17px;
  flex: 1;
  width: 100%;
  margin-bottom: 50px;
  @media ${device.laptop} {
    height: 340px;
    margin: 0 70px 0 0;
    &:last-child {
      margin: 0;
    }
  }

  & > div {
    text-align: center;
    width: 100%;
    display: block;

    &:first-child {
      margin-bottom: 60px;
    }
  }

  &:last-child {
    background: rgba(0, 171, 107, 0.05);
    box-shadow: 4px 4px 0 ${color.primary};
  }
`;

export const BoxContainer = styled(Flex).attrs({
  justify: 'space-between',
})`
  flex-direction: column;
  max-width: 1000px;
  margin: auto;

  @media ${device.laptop} {
    flex-direction: row;
  }
`;

export const PlanContainer = styled.div`
  width: calc(100% - 50px);
  margin: 50px auto;
  @media ${device.tablet} {
    max-width: 1300px;
    width: calc(100% - 150px);
  }
`;

export const Button = styled(Text).attrs({
  as: 'a',
  align: 'center',
  color: color.light,
  family: 'bold',
})`
  background: ${color.primary};
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  padding: 10px 20px;
  text-transform: uppercase;
  width: 100%;
  display: block;
  margin-top: 15px;

  &:hover {
    color: ${color.light};
  }

  @media ${device.laptop} {
    font-size: 17px;
  }
`;

export const BigText = styled(Text).attrs({
  as: 'span',
  align: 'center',
  color: color.primary,
  family: 'bold',
})`
  font-size: 22px;
  @media ${device.laptop} {
    font-size: 30px;
  }

  &.price {
    margin-left: 5px;
  }
`;
